import React from "react";
import Hero from "../components/Hero/Hero";
import Brands from "../components/Brands/Brands";
import FeaturedProducts from "../components/Products/FeaturedProducts";
import Gallery from "../components/Gallery/Gallery";
import WhyChooseUs from "../components/WhyUs/WhyChooseUs";
import Testimonials from "../components/Testimonials/Testimonials";

export default function Home() {
  return (
    <>
      <Hero />
      <Brands />
      <FeaturedProducts />
      <Gallery />
      <WhyChooseUs />
      <Testimonials />
    </>
  );
}
